import { FilterField, FilterFieldKey, FilterGroup } from './query.model';

/** The values of the ownership type, as in the filter form. */
export const OWNERSHIP_TYPES = [
  'Private',
  'Venture Capital',
  'Private Equity',
  'Public Sub',
  'Non-Profit',
  'Public',
  'Seed',
  'Private Sub',
  'Gov Agency',
  'Joint Venture',
  'Edu',
  'Other',
];

/** The review states, as in the filter form. */
export const REVIEW_STATUSES = [
  'Interesting - added to DealCloud',
  'Interesting - not added to DealCloud',
  'Not interesting',
  'Not reviewed',
];

const field = (
  key: FilterFieldKey,
  token: string,
  group: FilterGroup,
  kind: FilterField['kind'],
  extra: Partial<FilterField> = {}
): FilterField => ({
  key,
  token,
  aliases: [],
  label: `filter.field.${key}`,
  group,
  kind,
  ...extra,
});

/** Every field of the companies filter, in the order of the builder. */
export const FILTER_FIELDS: FilterField[] = [
  field('name', 'name', 'company', 'text'),
  field('sectors', 'sector', 'company', 'multi', { aliases: ['subsector'] }),
  field('country_code', 'country', 'company', 'multi'),
  field('city', 'city', 'company', 'text'),
  field('founded_at', 'founded', 'company', 'date-range'),
  field('ownership_type', 'ownership', 'company', 'enum', {
    options: OWNERSHIP_TYPES,
  }),
  field('keywords', 'keyword', 'company', 'multi', { aliases: ['keywords'] }),
  field('last_employee_count', 'employees', 'size', 'number-range'),
  field('last_employee_growth', 'growth', 'size', 'number-range'),
  field('revenue', 'revenue', 'size', 'money-range'),
  field('last_ebitda', 'ebitda', 'size', 'money-range'),
  field('investors', 'investor', 'funding', 'text'),
  field('last_investment_amount', 'funding', 'funding', 'money-range'),
  field('last_funded_year', 'funded', 'funding', 'year-range'),
  field('attractiveness_score', 'score', 'review', 'number-range'),
  field('review_status', 'status', 'review', 'enum', {
    options: REVIEW_STATUSES,
    valueAliases: {
      unreviewed: 'Not reviewed',
      'not-interesting': 'Not interesting',
      dealcloud: 'Interesting - added to DealCloud',
      interesting: 'Interesting - not added to DealCloud',
    },
  }),
  field('reviewer', 'reviewer', 'review', 'text'),
  field('business_id', 'ids', 'company', 'multi', { hidden: true }),
];

export const FILTER_FIELD_BY_KEY = new Map(
  FILTER_FIELDS.map((x) => [x.key, x] as const)
);

/** The field of a prefix or alias, ignoring case. */
export const fieldByToken = (token: string): FilterField | undefined => {
  const lower = token.toLowerCase();
  return FILTER_FIELDS.find(
    (x) => !x.hidden && (x.token === lower || x.aliases.includes(lower))
  );
};

export const isRangeKind = (kind: FilterField['kind']) =>
  kind.endsWith('-range');
